export default function About() {
  return (
    <section id="sobre" className="bg-[#0A0A0A] py-16 md:py-32 lg:py-44">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-12 gap-8 md:gap-12 lg:gap-16">
          {/* Left Column */}
          <div className="col-span-12 lg:col-span-5">
            <p className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] mb-10 md:mb-16 lg:mb-20 font-medium">
              Quem Somos
            </p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight">
              Experiência Sensorial<br />em Cada Detalhe
            </h2>
          </div>

          {/* Right Column */}
          <div className="col-span-12 lg:col-span-7 space-y-12 md:space-y-16 lg:space-y-24">
            {/* A Barem */}
            <div>
              <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] font-medium mb-6">
                A Barem
              </h3>
              <p className="text-[#999999] text-base font-light leading-relaxed">
                Barem Eventos eleva o padrão da coquetelaria em eventos sociais e corporativos. Não vendemos apenas drinks, vendemos experiência sensorial integrada à atmosfera do evento. Cada coquetel é uma obra de arte líquida, pensada para surpreender e encantar.
              </p>
            </div>

            {/* Filosofia */}
            <div>
              <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] font-medium mb-6">
                Filosofia
              </h3>
              <p className="text-[#999999] text-base font-light leading-relaxed">
                Unimos técnica clássica e coquetelaria contemporânea com curadoria de insumos premium. Nossa equipe altamente treinada entrega um serviço elegante, fluido e memorável, transformando o bar no protagonista da experiência.
              </p>
            </div>

            {/* Promessa */}
            <div>
              <h3 className="text-[#D4AF37] text-xs uppercase tracking-[0.15em] font-medium mb-6">
                Promessa
              </h3>
              <p className="text-[#999999] text-base font-light leading-relaxed">
                Cada evento é único. Desenvolvemos carta personalizada que reflete a identidade da celebração, garantindo que o bar seja não apenas um serviço, mas uma experiência inesquecível para seus convidados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}